import { Injectable } from "@angular/core";
import * as moment from "moment-timezone";
import { ContractManagementAppSettings } from "../ContractManagementAppSettings";

@Injectable()
export class DateTimeService {
    private timeZoneIdentifier: string;

    constructor() {
        this.timeZoneIdentifier = "Europe/Oslo";
    }

    get currentTimeZone(): string {
        return this.timeZoneIdentifier;
    }

    get currentDateTime(): moment.Moment {
        return moment
            .utc()
            .tz(this.timeZoneIdentifier);
    }
}



// WEBPACK FOOTER //
// ./src/app/Shared/DateTimeService.ts